import { FC } from 'react'
import { Row, Col, Button } from '@mch-group/uikit-components'
import { getShowPdf } from './utils'

interface IApplicationDocuments {
  data: any
  event: any
}

const ApplicationDocuments:FC<IApplicationDocuments> = ({ data, event }) => (
  <Row gutter='g-5 g-md-6 g-xl-7' className='mb-7 mb-sm-8 mb-xl-9'>
    <Col xs={12} >
      <a href={data.props[getShowPdf(event.name, 'guidelines', 'url')]} target='_blank' className='pdf-link'>
        <Button icon='redirect' iconAlign='left' variant='secondary'>
          {data.props[getShowPdf(event.name, 'guidelines', 'title')]}
        </Button>
      </a>
    </Col>
  </Row>
  )

export default ApplicationDocuments